angular
    .module('festzelt-os.modules.action_log')
    .factory('ActionLogEntry', [
        'Resource',
        (Resource) => {
            return Resource.make('action-log');
        }
    ]);





// WEBPACK FOOTER //
// ./src/app/modules/action_log/factories/action-log-entry-factory.js